import type { ISerialize } from '@/objects/ISerialize';
import { DynamicReportParameter } from './DynamicReportParameter';

export class DynamicReportRequest implements ISerialize {
    public CategoryIDs: number[];

    public GroupIDs: number[];

    public Parameters: DynamicReportParameter[];

    public RaceIDs: number[];

    public ReportID: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        CategoryIDs?: number[];
        GroupIDs?: number[];
        Parameters?: DynamicReportParameter[];
        RaceIDs?: number[];
        ReportID?: number;
    }) {
        this.CategoryIDs = values.CategoryIDs ?? [];

        this.GroupIDs = values.GroupIDs ?? [];

        this.Parameters = values.Parameters ?? [];

        this.RaceIDs = values.RaceIDs ?? [];

        this.ReportID = values.ReportID ?? 0;
    }

    public serialize(): string {
        return (
            '{' +
            `"CategoryIDs": [ ${this.CategoryIDs.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"GroupIDs": [ ${this.GroupIDs.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"Parameters": [ ${this.Parameters.map((x) => (!x ? null : x?.serialize()))} ]` +
            ',' +
            `"RaceIDs": [ ${this.RaceIDs.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"ReportID": ${JSON.stringify(this.ReportID)}` +
            '}'
        );
    }

    /**
     * Creates an instance of DynamicReportRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        CategoryIDs?: number[];
        GroupIDs?: number[];
        Parameters?: DynamicReportParameter[];
        RaceIDs?: number[];
        ReportID?: number;
    }): DynamicReportRequest {
        return new DynamicReportRequest(values);
    }

    public static _FromServerJson(json: any): DynamicReportRequest {
        return new DynamicReportRequest({
            CategoryIDs: json.CategoryIDs,
            GroupIDs: json.GroupIDs,
            Parameters: json.Parameters?.map((x: any) => DynamicReportParameter._FromServerJson(x)),
            RaceIDs: json.RaceIDs,
            ReportID: json.ReportID,
        });
    }

    /**
     * Creates an instance of DynamicReportRequest from another instance of DynamicReportRequest.
     * @param other The DynamicReportRequest you want to clone
     * @returns A cloned DynamicReportRequest
     */
    public static FromOther(other: DynamicReportRequest): DynamicReportRequest {
        return DynamicReportRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return DynamicReportRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'DynamicReportRequest';
}
